module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('transition', {
    attrs: {
      "name": "order-form"
    }
  }, [_c('div', {
    staticClass: "order-form-mask"
  }, [_c('div', {
    staticClass: "order-form"
  }, [_c('div', {
    staticClass: "contact-info-form"
  }, [_c('div', [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "placeholder": "必填",
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', [_vm._v("電話")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tel),
      expression: "tel"
    }],
    attrs: {
      "placeholder": "必填",
      "type": "tel"
    },
    domProps: {
      "value": _vm._s(_vm.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', [_vm._v("電子郵件")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": _vm._s(_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', [_vm._v("備註")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notes),
      expression: "notes"
    }],
    domProps: {
      "value": _vm._s(_vm.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notes = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "product-summary"
  }, [_c('div', {
    staticClass: "available-components"
  }, _vm._l((_vm.availableComponents), function(type) {
    return _c('div', [_c('div', [_c('b', [_vm._v(_vm._s(type.title))])]), _vm._v(" "), _vm._l((type.components), function(component) {
      return (component.price > 0) ? _c('div', {
        staticClass: "info-item"
      }, [_c('div', {
        staticClass: "info-item-title"
      }, [_vm._v(_vm._s(component.info))]), _vm._v(" "), _c('div', {
        staticClass: "info-item-text"
      }, [_vm._v("$ " + _vm._s(_vm._f("priceTag")(component.price)))])]) : _vm._e()
    })], true)
  })), _vm._v(" "), _c('div', {
    staticClass: "price-summary"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "info-item-title"
  }, [_vm._v("單價")]), _vm._v(" "), _c('div', {
    staticClass: "info-item-text"
  }, [_vm._v("NT$ " + _vm._s(_vm._f("priceTag")(_vm.productPrice)))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "info-item-title"
  }, [_vm._v("數量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productCount),
      expression: "productCount"
    }],
    staticClass: "info-item-text",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": _vm._s(_vm.productCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productCount = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "info-item-title"
  }, [_vm._v("總價")]), _vm._v(" "), _c('div', {
    staticClass: "info-item-text"
  }, [_vm._v("NT$ " + _vm._s(_vm._f("priceTag")(_vm.totalPrice)))])])]), _vm._v(" "), _c('div', {
    staticClass: "navigation-buttons"
  }, [_c('span', {
    staticClass: "cancel-btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm-btn",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("確認訂購")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fe4888f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order-form.vue
// module id = 201
// module chunks = 5